var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

var _isSP;
var windowW = window.innerWidth;
var prewidth = window.innerWidth;

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();

//divideCharacter
import {divideCharacter} from "../include/module";
divideCharacter();

$(window).on('load' , function() {

  scrollCommonAnime();

});


  // ------------------------------------------------------------------------
// scrollCommonAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollCommonAnime = () => {

  const controller = new ScrollMagic.Controller();

  //　スクロールで発火
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
  new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .9
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });



};



// WEBPACK FOOTER //
// ./src/watakon_v0/assets/js/common/script.js